import {combineReducers} from 'redux'
import {routeReducer} from '../core/redux/router'
import {loadingReducer} from '../core/redux/loading'
import {progressReducer} from '../core/redux/progress'
import {uiReducer} from '../core/redux/ui'
import {statusReducer} from '../core/redux/status'
import patrimonyReducers from '../patrimony/reducers'
import ticketReducers from '../ticket/reducers'
import claimReducers from '../claim/reducers'
import companyReducers from '../company/reducers'
import userReducers from '../user/reducers'
import providerReducers from '../provider/reducers'
import workflowReducers from '../workflow/reducers'
import messageReducers from '../message/reducers'
import referenceReducers from '../reference/reducers'
import satisfactionReducers from '../satisfaction/reducers'
import auditReducers from '../audit/reducers'
import actradisReducers from '../actradis/reducers'

import {LINKS_LOADED, VERSION_LOADED} from './actions'

function _links(state = [], action) {
    switch (action.type) {
        case LINKS_LOADED:
            return action._links
        default:
            return state
    }
}

function version(state = null, action) {
    switch (action.type) {
        case VERSION_LOADED:
            return action.version
        default:
            return state
    }
}

export default combineReducers({
	app: combineReducers({
		_links,
        version
	}),
    router: routeReducer,
    loading: loadingReducer,
    progress: progressReducer,
    ui: uiReducer,
    status: statusReducer,
    patrimony: patrimonyReducers,
    ticket: ticketReducers,
    claim: claimReducers,
    company: companyReducers,
    user: userReducers,
    provider: providerReducers,
    workflow: workflowReducers,
    message: messageReducers,
    reference: referenceReducers,
    satisfaction: satisfactionReducers,
    audit: auditReducers,
    actradis: actradisReducers
})


// WEBPACK FOOTER //
// ./lib/app/reducers.js